module.exports = __webpack_public_path__ + "img/review_specs.22923054.png";